import { number } from "./number"

const months = [
    { Baisakh: "बैशाख" },
    { Jestha: "जेठ" },
    { Ashad: "आषाढ" },
    { Shrawan: "श्रावण" },
    { Bhadra: "भाद्र" },
    { Aswin: "आश्विन" },
    { Kartik: "कार्तिक" },
    { Mangsir: "मंसिर" },
    { Poush: "पुस" },
    { Magh: "माघ" },
    { Falgun: "फागुन " },
    { Chaitra: "चैत्र" },
]

const monthsFY = [
    { Shrawan: "श्रावण" },
    { Bhadra: "भाद्र" },
    { Aswin: "आश्विन" },
    { Kartik: "कार्तिक" },
    { Mangsir: "मंसिर" },
    { Poush: "पुस" },
    { Magh: "माघ" },
    { Falgun: "फागुन " },
    { Chaitra: "चैत्र" },
    { Baisakh: "बैशाख" },
    { Jestha: "जेठ" },
    { Ashad: "आषाढ" },
]

const getLanguage = () => {
    return window.language
}

export const getMonthName = monthInNumber => {
    if (months[monthInNumber]) {
        const language = getLanguage()
        return language === "np"
            ? Object.values(months[monthInNumber])[0]
            : Object.keys(months[monthInNumber])[0]
    }
}

export const getAllMonths = () => {
    const language = getLanguage()
    let filteredMonths = []
    monthsFY.forEach(month => {
        const filteredMonth =
            language === "np" ? Object.values(month)[0] : Object.keys(month)[0]
        filteredMonths.push(filteredMonth)
    })
    return filteredMonths
}

export const date = date => {
    if (date) {
        return number(
            getMonthName(date.getMonth()) +
            " " +
            date.getDate() +
            ", " +
            date.getFullYear(),
        )
    }
    return date
}

export const nepaliFormattedDate = dateString => {
    if (!dateString) {
        return ""
    }
    const splittedDate = `${dateString}`.split("/")
    if (splittedDate) {
        return number(
            getMonthName(splittedDate[1] - 1) +
            " " +
            splittedDate[2] +
            ", " +
            splittedDate[0],
        )
    }
    return date
}



// WEBPACK FOOTER //
// ./src/localization/month.js